import {
  forwardRef, memo, useCallback, useEffect, useMemo, useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import Styles from './styles.module.scss';
import useSizes from '../../../hooks/sizes';
import { toggleStoryFilters } from '../../../actions/preferencesActions';
import ItemsScrollBar from '../ItemsScrollBar';
import StorageSvc from '../../../services/StorageSvc';

const cx = classNames.bind(Styles);

const ScrollableTabs = ({
  tabs,
  activeTab,
  onTabClick,
  className,
  withUnderline = false,
  classname,
  arrowClassName = '',
  mainClassName = '',
  itemClassName = '',
}, ref) => {
  const { width } = useSizes();
  const { height: promobarHeight } = useSelector((state) => state.promobar);
  const dispatch = useDispatch();
  const scrollPointRef = useRef();

  const data = useMemo(() => (
    tabs.map((tab) => ({ ...tab, active: activeTab === tab.id }))
  ), [tabs, activeTab]);

  const onTabChange = useCallback((id) => {
    const tabTop = scrollPointRef.current.getBoundingClientRect().top;
    if (tabTop <= 0) {
      const offsetTop = window.pageYOffset + tabTop;
      onTabClick(id, offsetTop);
    } else {
      onTabClick(id);
    }
    dispatch(toggleStoryFilters(false));
  }, [dispatch, onTabClick]);

  useEffect(() => {
    if (typeof ref === 'function') {
      ref(scrollPointRef.current);
    } else if (ref instanceof Object && 'current' in ref) {
      ref.current = scrollPointRef.current;
    }
  }, [ref]);

  useEffect(() => {
    if (!(width > 767 || StorageSvc.getItem('mobilePopupSeen'))) {
      return;
    }

    document.querySelector(':root').style.setProperty(
      '--promobar-height',
      `${promobarHeight}px`,
    );
  }, [width, promobarHeight]);

  return (
    <>
      <div ref={scrollPointRef} id="watchlists_tab_bar_holder" />
      <div className={cx('scrollable_tabs', className)}>
        <ItemsScrollBar
          onClick={onTabChange}
          data={data}
          scrollToSelected
          withUnderline={withUnderline}
          arrowClassName={cx('scrollable_tabs_arrow', arrowClassName)}
          className={cx('scrollable_tabs_container', classname, mainClassName)}
          itemClassName={cx('scrollable_tabs_item', itemClassName)}
        />
      </div>
    </>
  );
};

export default memo(forwardRef(ScrollableTabs));
